import { type IServicesCollection } from 'src/packages/di';

import type { ILanguageService } from './ILanguageService';
import { LanguageStore } from './LanguageStore';

declare module 'src/packages/di' {
  export interface ServicesCollectionMap {
    language: ILanguageService;
  }
}

export const addLanguageService = (di: IServicesCollection) => {
  const service = new LanguageStore(di.requireService('i18'));
  service.init();

  di.addSingleton('language', service);
};
